import hydrate from '../common/hydrate';
import HomepageTopTeaser from './components/HomepageTopTeaser';
import { root, name } from './manifest.json';
hydrate(HomepageTopTeaser, root, name);
if (module.hot) {
    module.hot.accept();
}
